export enum RedirectEntryType {
  ISBN = "ISBN",
  PAGE = "PAGE",
  ACADEMIC_ARTICLE = "ACADEMIC_ARTICLE",
  ARTICLE = "ARTICLE",
  TEMPLATE = "TEMPLATE"
}

export interface RedirectEntry {
  type: RedirectEntryType;
  resource: string;
  target: string;
  redirectCode: number;
  active: boolean;
}